import { createTheme } from '@mui/material/styles';

/**
 * The Copilot caption window's type scale.
 *
 * OPUS-1637 asks for larger type. Applying it as a theme at the mount means the
 * form-library fragments inherit it without any of them changing, and without
 * touching the shared aeTheme in @ae/ui that every AeDrive surface uses.
 *
 * Built from the host theme, so palette, shape and component defaults carry
 * through — only the type scale is Copilot's.
 */
const COPILOT_BASE_FONT_SIZE = 17;

export const buildCopilotTheme = (parentTheme) =>
  createTheme(parentTheme, {
    typography: {
      fontSize: COPILOT_BASE_FONT_SIZE,
      button: { fontWeight: 700 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          // Operators read words under pressure; SHOUTING CAPS is slower to
          // scan than sentence case.
          root: { textTransform: 'none' },
        },
      },
    },
  });
